import { createAction } from '@reduxjs/toolkit';

import type { Blueprint, PublicBlueprintList } from 'js/src/client/types.gen';

type BlueprintItem = PublicBlueprintList | Blueprint;
import { ACTIONS } from 'js/src/data/blueprints/blueprints-types';

export const pushBlueprint = createAction<{
    blueprint: BlueprintItem;
}>(ACTIONS.PUSH_BLUEPRINT);

export const pushBlueprints = createAction<{
    blueprints: BlueprintItem[];
}>(ACTIONS.PUSH_BLUEPRINTS);

export const removeBlueprint = createAction<{
    blueprintId: number;
}>(ACTIONS.REMOVE_BLUEPRINT);

export const setBlueprintName = createAction<{
    name: string;
    blueprintId: number;
}>(ACTIONS.SET_BLUEPRINT_NAME);

export const setBlueprintsLoading = createAction<{
    loading: boolean;
}>(ACTIONS.SET_BLUEPRINTS_LOADING);
